export const page = {
    root:{
        backgroundSize:"auto",  
        position:"relative",
    }
}